import { getInitialsName } from 'util/string';
import * as Yup from 'yup';

export const getSchema = () => {
  return Yup.object().shape({
    full_name: Yup.string().nullable(),
    short_name: Yup.string()
      .min(2, 'Must be at least 2 characters')
      .required('This field is required'),
  });
};
export const getInitialValues = user => {
  return {
    full_name: user?.name,
    short_name: getInitialsName(user?.name),
  };
};
